module.exports = __webpack_public_path__ + "img/dummyprod1@1x.0bb435c0.png";